import { PokerGameFormatType, PokerGameType } from 'mvppoker-portal-common/api'
import React from 'react'
import { classNames } from '../../../utils/cssUtils'
import { MVPButton } from '../../../Views/Buttons/MVPButton'
import './FilteringBox.scss'

export interface RoomListOptions {
	format: PokerGameFormatType
	game: PokerGameType | 'All'
	filteringOption: 'stakes' | 'avg-pot' | 'players'
	filteringOrder: 'asc' | 'desc'
}

export const FilteringBox = ({
	options,
	onClickFormat,
	onClickGame,
	onClickOption
}: {
	options: RoomListOptions,
	onClickFormat: (option: RoomListOptions['format']) => void,
	onClickGame: (option: RoomListOptions['game']) => void,
	onClickOption: (option: RoomListOptions['filteringOption']) => void
}) => {
	const getClass = (field:  RoomListOptions['format'] | RoomListOptions['game'] | RoomListOptions['filteringOption'], options: RoomListOptions) =>
		classNames('semiround small', { clear: options.format !== field && options.game !== field && options.filteringOption !== field })

	return (
		<div id='filtering-box'>
			<h3>Types</h3>
			<div className='flex gap-2'>
				<MVPButton id='type-filters-button' className={getClass('CASH', options)} onClick={() => onClickFormat('CASH')}>
					Cash
				</MVPButton>
				<MVPButton id='type-filters-button' className={getClass('SNG', options)} onClick={() => onClickFormat('SNG')}>
					Sit & Go<br/>(SNG)
				</MVPButton>
			</div>
			<h3>Filtering Options</h3>
			<div id='filters'>
				<MVPButton className={getClass('stakes', options)} onClick={() => onClickOption('stakes')}>
					STAKES
				</MVPButton>
				<MVPButton className={getClass('avg-pot', options)} onClick={() => onClickOption('avg-pot')}>
					AVG. POT
				</MVPButton>
				<MVPButton className={getClass('players', options)} onClick={() => onClickOption('players')}>
					PLAYERS
				</MVPButton>
			</div>
			<h3>Games</h3>
			<div className='flex gap-2'>
				<MVPButton id='reset-filters-button' className={getClass('All', options)} onClick={() => onClickGame('All')}>
					All
				</MVPButton>
				<MVPButton id='reset-filters-button' className={getClass('HOLDEM', options)} onClick={() => onClickGame('HOLDEM')}>
					Holdem
				</MVPButton>
				<MVPButton id='reset-filters-button' className={getClass('OMAHA', options)} onClick={() => onClickGame('OMAHA')}>
					Omaha
				</MVPButton>
			</div>
		</div>
	)
}
